// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VrmS","right":"styles_right__2FWP3"};